// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Image from "components/layout/Image";

// #####################################################

export const StyledBluredAvatar = styled(Image)`
	filter: blur(20px);
	display: inline-block;
	width: 100%;
	height: auto;
	position: absolute;
	top: -50%;
	transform: scale(1.05);
	left: 0;
`;

// #####################################################
